<template>
  <div class="split-modal-wrapper">
    <!-- <h2 class="split-modal-header">{{ $t('split.title') }}</h2> -->

    <NavbarDesktop
      v-if="isDesktop"
      @onConfirmAction="emitSplit"
      @onDiscardAction="emitCancel()"
      :action="{ type: 'split' }"
    />
    <div class="split-modal-body">
      <QueueItem
        class="split-item"
        :order="initialOrder"
        @splitClick="handleSplitClick"
        readonly
        splitting
        v-if="initialOrder.list"
      />

      <div v-if="!isDesktop" class="fixed-wrapper">
        
          <QueueButton class="action-cancel-button" @click="emitCancel">
            <img src="/icons/back2.svg" class="del" />
          </QueueButton>
          <QueueButton variant="confirm" class="w-100" :disabled="!canSplit" @click="emitSplit">
            {{ $t('split.confirm') }}
            <span v-if="canSplit">({{splittedChecksAmount}}x)</span>
          </QueueButton>
         
      </div>
    </div>
  </div>
</template>

<script>
import QueueItem from "@/components/QueueItem.vue";
import QueueButton from "@/components/QueueButton.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";
export default {
  props: {
    order: Object,
  },
  data() {
    return {
      initialOrder: null,
      list: [],
    };
  },
  methods: {
    emitSplit() {
      this.$emit("split", this.initialOrder.list);
    },
    emitCancel() {
      this.$emit("cancel");
    },
    handleSplitClick(order_id, idx) {
      let val = this.initialOrder.list[idx].splitIndex;

      val++;

      if (val > 4) {
        val = 0;
      }

      this.initialOrder.list[idx].splitIndex = val;
    },
    makeList() {
      let list = [];

      this.initialOrder.list.forEach((item, index) => {
        for (let i = 0; i < item.quantity; i++) {
          const new_item = Object.assign({}, item);

          new_item.splitIndex = 0;
          new_item.quantity = 1;

          list.push(new_item);
          // this.$set(this.initialOrder.list[index], "splitIndex", 0);
        }
      });

      this.$set(this.initialOrder, "list", list);
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    canSplit() {
      if (!this.initialOrder) return false;

      let counters = [0, 0, 0, 0, 0];

      this.initialOrder.list.forEach((item) => {
        counters[item.splitIndex]++;
      });

      let max = counters[0];

      counters.forEach((c) => {
        if (c > max) max = c;
      });

      if (max === this.initialOrder.list.length) {
        return false;
      } else {
        return true;
      }
    },
    splittedChecksAmount() {
      if (!this.initialOrder) return 0;

      let counters = [0, 0, 0, 0, 0];

      this.initialOrder.list.forEach((item) => {
        counters[item.splitIndex]++;
      });

      return counters.filter((c) => c > 0).length;
    },
  },
  mounted() {
    this.initialOrder = JSON.parse(JSON.stringify(this.order));

    this.makeList();
  },
  components: {
    QueueItem,
    QueueButton,
    NavbarDesktop,
  },
};
</script>

<style scoped>
.split-modal-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  background: #ededed;
  z-index: 2;
  top: 0;
  position: fixed;
  width: 100%;
  padding-bottom: 25vh;
}

.action-cancel-button {
  width: 7vh !important;
}

.mb-10 {
  margin-bottom: 1vh;
}

.split-item {
  border-radius: 2.5vh;
}

.w-80 {
  width: 80% !important;
}

.mt-10 {
  margin-top: 1.2vh;
}
.fixed-wrapper {
  background: #1d1d1d;
    bottom: 0;
    display: flex;
  
    justify-content: space-between;
    padding: 1.3vh 3.2vh 2.6vh;
    z-index: 5;
    width: 100%;
    position: fixed;
    left: 0;
}

.split-modal-header {
  position: absolute;
  left: 2.5vh;
  top: 8vh;
  width: 100%;
  margin: 0;
  z-index: 2;
  font-size: 3vh;
  color: black;
}

.split-modal-body {
  position: relative;
  top: 8vh;
  left: 0;
  height: 100vh;
  width: 100%;
  margin-bottom: 5vh;
  padding: 0 2.5vh 7vh;
  z-index: 2;
}
@media screen and (min-width: 765px) {
  .split-modal-body {
    top: 0;
    display: flex;
    padding: 0;
    margin: 0;
    justify-content: center;
    align-items: flex-start;
    padding-top: 9.722vw;
  }
  .split-modal-wrapper {
    padding: 0;
    margin: 0;
  }
  .split-modal-wrapper::-webkit-scrollbar {
    width: 0;
  }
}
</style>
